
export const Github = (props) => {
    return (
        <svg
          aria-hidden="true"
          data-prefix="fab"
          data-icon="github"
          className="prefix__svg-inline--fa prefix__fa-github prefix__fa-w-16"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 496 512"
          {...props}
        >
          <path
            fill={props.fill}
            d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
          />
        </svg>
      )
}

export const Twitter = (props) => {
    return (
        <svg
          aria-hidden="true"
          data-prefix="fab"
          data-icon="twitter"
          className="prefix__svg-inline--fa prefix__fa-twitter prefix__fa-w-16"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          {...props}
        >
          <path
            fill={props.fill}
            d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
          />
        </svg>
      )
}

export const Facebook = (props) => {
    return (
        <svg
          aria-hidden="true"
          data-prefix="fab"
          data-icon="facebook"
          className="prefix__svg-inline--fa prefix__fa-facebook prefix__fa-w-16"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          {...props}
        >
          <path
            fill={props.fill}
            d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
          />
        </svg>
      )
}

export const Instagram = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} {...props}>
      <path d="M7.547 0C3.39 0 0 3.39 0 7.547v10.906C0 22.61 3.39 26 7.547 26h10.906C22.61 26 26 22.61 26 18.453V7.547C26 3.39 22.61 0 18.453 0Zm0 2h10.906A5.53 5.53 0 0 1 24 7.547v10.906A5.53 5.53 0 0 1 18.453 24H7.547A5.53 5.53 0 0 1 2 18.453V7.547A5.53 5.53 0 0 1 7.547 2ZM20.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM13 6c-3.855 0-7 3.145-7 7s3.145 7 7 7 7-3.145 7-7-3.145-7-7-7Zm0 2c2.773 0 5 2.227 5 5s-2.227 5-5 5-5-2.227-5-5 2.227-5 5-5Z" />
    </svg>
  )
}

export const Design = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="palette"
      className="prefix__svg-inline--fa prefix__fa-palette prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill={props.fill}
        d="M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
      />
    </svg>
  )

}

export const WebDevelopementSkill = (props) => (
  <svg
    id="Icons"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 32 32"
    style={{
      enableBackground: "new 0 0 32 32",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style>
      {
        ".st0{fill:none;stroke:#000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}"
      }
    </style>
    <path d="M27 4H5C3.3 4 2 5.3 2 7v18c0 1.7 1.3 3 3 3h22c1.7 0 3-1.3 3-3V7c0-1.7-1.3-3-3-3zM9.1 7.6c.1-.1.1-.2.2-.3.1-.1.2-.2.3-.2.4-.2.8-.1 1.1.2.1.1.2.2.2.3.1.1.1.3.1.4 0 .3-.1.5-.3.7-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.2-.2-.3-.4-.3-.7 0-.1 0-.3.1-.4zM6 8c0-.3.1-.5.3-.7l.1-.1c.1 0 .1-.1.2-.1.1-.1.1-.1.2-.1h.4c.1 0 .1 0 .2.1.1 0 .1.1.2.1l.1.1c.1.1.2.2.2.3.1.1.1.3.1.4 0 .1 0 .3-.1.4 0 .1-.1.2-.2.3-.2.2-.4.3-.7.3s-.5-.1-.7-.3C6.1 8.5 6 8.3 6 8zm5.7 13.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3s-.5-.1-.7-.3l-3-3c-.4-.4-.4-1 0-1.4l3-3c.4-.4 1-.4 1.4 0s.4 1 0 1.4L9.4 19l2.3 2.3zm.9-12.4c-.1-.1-.2-.1-.3-.2-.1-.1-.2-.2-.2-.3-.1-.1-.1-.3-.1-.4 0-.1 0-.3.1-.4.1-.1.1-.2.2-.3.4-.4 1-.4 1.4 0 .1.1.2.2.2.3.1.1.1.3.1.4 0 .1 0 .3-.1.4-.1.1-.1.2-.2.3-.2.2-.4.3-.7.3-.1 0-.3 0-.4-.1zm6.3 6.5-4 8c-.2.4-.5.6-.9.6-.2 0-.3 0-.4-.1-.5-.2-.7-.8-.4-1.3l4-8c.2-.5.8-.7 1.3-.4.4.2.6.8.4 1.2zm5.8 4.3-3 3c-.2.2-.4.3-.7.3s-.5-.1-.7-.3c-.4-.4-.4-1 0-1.4l2.3-2.3-2.3-2.3c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l3 3c.4.4.4 1 0 1.4z" />
  </svg>
)

export const AppDevelopmentSkill = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 337.051 337.051"
    style={{
      enableBackground: "new 0 0 337.051 337.051",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path d="M198.919 193.488c0-8.157-5.169-12.294-15.362-12.294h-7.054v24.973h7.054c10.193.001 15.362-4.265 15.362-12.679zM246.657 193.773c0-8.157-5.168-12.294-15.361-12.294h-7.055v24.972h7.055c10.193 0 15.361-4.266 15.361-12.678zM130.091 188.301l-9.126 19.935h18.366z" />
    <path d="M327.051 92.432h-6.877V75.556c0-11.028-8.972-20-20-20h-12.121V43.435c0-11.028-8.972-20-20-20H20c-11.028 0-20 8.972-20 20v201.184c0 11.028 8.972 20 20 20h12.121v12.121c0 11.028 8.971 20 20 20h16.877v6.876c0 5.523 4.477 10 10 10h248.053c5.523 0 10-4.477 10-10V102.432c0-5.523-4.477-10-10-10zM100.875 227.554l24.539-53.601a5.114 5.114 0 0 1 4.637-2.984c1.973.021 3.812 1.152 4.65 2.963l24.844 53.6a5.112 5.112 0 0 1-9.277 4.3l-6.197-13.371h-27.786l-6.111 13.349a5.115 5.115 0 0 1-6.776 2.521 5.114 5.114 0 0 1-2.523-6.777zm65.403 2.128v-53.6a5.112 5.112 0 0 1 5.112-5.112h12.166c15.782 0 25.587 8.628 25.587 22.518 0 14.128-9.805 22.904-25.587 22.904h-7.054v13.29a5.112 5.112 0 0 1-10.224 0zm47.739.284v-53.6a5.112 5.112 0 0 1 5.112-5.112h12.167c15.782 0 25.586 8.628 25.586 22.518 0 14.127-9.804 22.903-25.586 22.903h-7.055v13.291a5.112 5.112 0 0 1-10.224 0zm69.382-22.265c-8.457-2.562-20.04-6.07-20.04-19.734 0-10.167 8.927-16.998 22.213-16.998 5.992 0 12.52 1.812 17.035 4.729a5.114 5.114 0 0 1-5.548 8.589c-2.863-1.85-7.479-3.093-11.486-3.093-5.53 0-11.988 1.774-11.988 6.773 0 5.528 3.698 7.198 12.779 9.948 8.179 2.477 19.379 5.87 19.272 18.773 0 9.896-8.741 16.573-21.751 16.573-7.881 0-15.915-3.315-20.967-8.653a5.113 5.113 0 1 1 7.426-7.028c3.089 3.264 8.531 5.457 13.541 5.457 5.317 0 11.525-1.674 11.525-6.391.039-4.604-2.671-6.116-12.011-8.945zM20 43.435h248.053v12.121H52.121c-11.029 0-20 8.972-20 20v169.063H20V43.435zm32.121 233.304V75.556h248.053v16.876H78.998c-5.523 0-10 4.477-10 10v174.307H52.121z" />
  </svg>
)

export const DesignSkill = (props) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 122.88 112.71"
    {...props}
  >
    <defs>
      <style>{".cls-1{fill:#42a5f5;fill-rule:evenodd}"}</style>
    </defs>
    <title>{"paint-bucket"}</title>
    <path
      className="cls-1"
      d="M6.56 52c26.55 5.3 36.62 37.47 79.73 15.8L58 96.06s-.57.58-.63.65a7 7 0 0 1-4.29 2.56 13.6 13.6 0 0 1-4.2.24 21.48 21.48 0 0 1-4.8-1.06c-7.4-2.48-15.17-7.8-21.79-14.37S10.22 69.62 7.61 62.19a25.29 25.29 0 0 1-1-3.74 17.9 17.9 0 0 1-.33-3.3A12.86 12.86 0 0 1 6.56 52Z"
    />
    <path d="M110.56 84.94c-1.21-1.85-2.44-3.72-3.61-5.64-1.35 2.26-2.77 4.48-4.15 6.64-3.51 5.48-6.72 10.51-6.72 12.55 0 4.65 2.24 7.71 5.23 9.21a12.56 12.56 0 0 0 4.94 1.25 13 13 0 0 0 5.16-.74 9.49 9.49 0 0 0 6.36-8c.13-4.1-3.44-9.53-7.21-15.27Z" />
    <path d="M111.24 72.76c.82 3.48 3.17 7.06 5.43 10.5 3.35 5.1 6.52 9.93 6.18 15.51v.22a14.76 14.76 0 0 1-10 12.68 17.35 17.35 0 0 1-6.85 1 17 17 0 0 1-6.73-1.76A14.85 14.85 0 0 1 91 97c0-3.86 2.79-8.22 5.83-13 2.46-3.84 5.11-8 5.86-11.25a4.41 4.41 0 0 1 8.59 0Z" />
    <path
      className="cls-1"
      d="M107 73.76c2.15 9.2 12 17.11 11.5 24.75-1.49 13.54-23.07 13-23.07-1.51 0-5.18 9.72-15.25 11.57-23.24Z"
    />
    <path d="M34.65 13.77c-10.22 1.1-16.22 4.63-19 9.11a13.37 13.37 0 0 0-1.23 10.65l.09.34 20.11-20.1ZM80.8 24.89c-7.29-7.3-14.66-13-20.73-16.17-4.31-2.22-7.67-3.11-9.32-2.17l-.82.82c-1.22 2-.51 6.26 1.78 11.58a68.81 68.81 0 0 0 14.51 20.52c6.94 6.94 14.39 12.14 20.73 15 4.51 2 8.21 2.9 10.35 2.32l1.91-1.92c.45-1.91-.5-5.14-2.49-9.13C93.63 39.53 88 32.08 80.8 24.89ZM62.94 3.15c6.66 3.43 14.58 9.57 22.31 17.3S99 36.15 102.34 43c3.75 7.51 4.35 13.92.69 17.58A8.23 8.23 0 0 1 101 62l-39.12 39.1c-2.35 2.37-3.33 3.37-7.38 4.28a19.93 19.93 0 0 1-6.14.36 27.5 27.5 0 0 1-6.24-1.35c-8.33-2.8-17-8.66-24.22-15.86S4.63 72.6 1.7 64.25A30.28 30.28 0 0 1 .43 59.6 23.6 23.6 0 0 1 0 55.15a15.25 15.25 0 0 1 1.23-6.81A17.84 17.84 0 0 1 5 43.42l.16-.17 4.71-4.7a24.06 24.06 0 0 1-1.22-3.45 19.15 19.15 0 0 1 1.92-15.34C14.84 12.78 24.42 7.59 41 7.42l4.17-4.16a7.06 7.06 0 0 1 1.58-1.57 2.46 2.46 0 0 1 .67-.45C51.13-1 56.62-.11 62.94 3.15Zm28.54 59.46a35.83 35.83 0 0 1-7.11-2.42c-7-3.16-15.11-8.81-22.59-16.28a75.25 75.25 0 0 1-15.84-22.48 34.92 34.92 0 0 1-2.39-7.68l-26.11 26.1a25.47 25.47 0 0 0 4.1 4.58c7.26 6.43 18.87 9.69 31.64 4.22a3 3 0 0 1 2.35 5.52c-15.21 6.51-29.17 2.52-38-5.25a32 32 0 0 1-4.42-4.78l-3.67 3.71A12.66 12.66 0 0 0 6.9 51a9.73 9.73 0 0 0-.64 4.14 17.9 17.9 0 0 0 .33 3.3 25.29 25.29 0 0 0 1 3.74c2.61 7.43 8 15.27 14.71 21.89S36.71 96 44.11 98.45a21.48 21.48 0 0 0 4.8 1.06 13.6 13.6 0 0 0 4.2-.24 7 7 0 0 0 4.29-2.56c.06-.07.64-.64.63-.65l33.45-33.45Z" />
  </svg>
)

export const EducationIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 480.001 480.001"
    style={{
      enableBackground: "new 0 0 480.001 480.001",
    }}
    xmlSpace="preserve"
    {...props}
    >
    <path d="M473.679 138.257 238.348 45.145a9.996 9.996 0 0 0-7.32-.015L6.359 132.968a10.002 10.002 0 0 0 .072 18.655l69.068 26.39v122.285a10 10 0 0 0 6.217 9.257l150.878 61.651c.317.129.638.24.963.335.045.014.092.021.138.034.36.1.724.177 1.089.235a10.159 10.159 0 0 0 1.509.135c.03 0 .06.006.09.006.441 0 .885-.041 1.328-.101.098-.013.195-.03.292-.046.365-.061.728-.142 1.089-.244.083-.023.167-.041.249-.067a9.88 9.88 0 0 0 1.146-.429l79.955-36.053c.045.973.23 1.908.536 2.791-.014.056-.036.107-.049.163l-18.718 85.453a10 10 0 0 0 12.935 11.625l63.205-21.099a10 10 0 0 0 5.059-15.172l-43.163-62.439c.091-.502.156-1.013.17-1.539.038-1.481.103-4.564.134-8.851l58.06-26.181a10.001 10.001 0 0 0 5.89-9.116v-108.98l68.875-24.699a10 10 0 0 0 .303-18.71zM226.377 347.061 95.499 293.582V185.655l130.878 50.007v111.399zm19.998-.592V238.371l62.242-22.32c8.727 23.894 11.397 67.355 11.859 97.005l-74.101 33.413zm113.011 52.722-33.87 11.306 10.03-45.792 23.84 34.486zm-19.046-95.092c-.721-28.083-3.51-68.578-12.971-94.772l57.132-20.488v95.347l-44.161 19.913zm-22.349-112.656c-24.541-32.27-87.574-55.77-90.332-56.786-5.18-1.911-10.931.744-12.84 5.926-1.909 5.182.744 10.931 5.926 12.84 15.917 5.864 57.441 24.334 77.149 45.226l-57.957 20.783-202.2-77.258 196.91-76.985 207.01 81.906-123.666 44.348z" />
  </svg>
)
